import { CometChat as CometChatSDK } from '@cometchat/chat-sdk-javascript';

export const CometChat = CometChatSDK;
